/*
 * @Author: KingNa
 * @Date: 2017-09-28 14:04:38
 * @Last Modified by: wyh
 * @Last Modified time: 2019-08-09 18:55:45
 * @Description:
 *      日期类服务
 *      1、获取时间（农历：getChineseDate，阳历：getNowTime）
 *      2、获取当前间隔天数：getFormatDate
 *
 */
import { Injectable } from "@angular/core";
import "rxjs/add/operator/map";
import { Platform } from "ionic-angular";
import { Storage } from "@ionic/storage";

@Injectable()
export class DateUtilProvider {
  //定义全局变量
  CalendarData = new Array(100);
  madd = new Array(12);
  tgString = "甲乙丙丁戊己庚辛壬癸";
  dzString = "子丑寅卯辰巳午未申酉戌亥";
  numString = "一二三四五六七八九十";
  monString = "正二三四五六七八九十冬腊";
  weekString = "日一二三四五六";
  sx = "鼠牛虎兔龙蛇马羊猴鸡狗猪";
  cYear;
  cMonth;
  cDay;
  TheDate;

  constructor(
    private platform: Platform,
    private storage: Storage,
  ) {
    this.CalendarData = new Array(
      0xa4b,
      0x5164b,
      0x6a5,
      0x6d4,
      0x415b5,
      0x2b6,
      0x957,
      0x2092f,
      0x497,
      0x60c96,
      0xd4a,
      0xea5,
      0x50da9,
      0x5ad,
      0x2b6,
      0x3126e,
      0x92e,
      0x7192d,
      0xc95,
      0xd4a,
      0x61b4a,
      0xb55,
      0x56a,
      0x4155b,
      0x25d,
      0x92d,
      0x2192b,
      0xa95,
      0x71695,
      0x6ca,
      0xb55,
      0x50ab5,
      0x4da,
      0xa5b,
      0x30a57,
      0x52b,
      0x8152a,
      0xe95,
      0x6aa,
      0x615aa,
      0xab5,
      0x4b6,
      0x414ae,
      0xa57,
      0x526,
      0x31d26,
      0xd95,
      0x70b55,
      0x56a,
      0x96d,
      0x5095d,
      0x4ad,
      0xa4d,
      0x41a4d,
      0xd25,
      0x81aa5,
      0xb54,
      0xb6a,
      0x612da,
      0x95b,
      0x49b,
      0x41497,
      0xa4b,
      0xa164b,
      0x6a5,
      0x6d4,
      0x615b4,
      0xab6,
      0x957,
      0x5092f,
      0x497,
      0x64b,
      0x30d4a,
      0xea5,
      0x80d65,
      0x5ac,
      0xab6,
      0x5126d,
      0x92e,
      0xc96,
      0x41a95,
      0xd4a,
      0xda5,
      0x20b55,
      0x56a,
      0x7155b,
      0x25d,
      0x92d,
      0x5192b,
      0xa95,
      0xb4a,
      0x416aa,
      0xad5,
      0x90ab5,
      0x4ba,
      0xa5b,
      0x60a57,
      0x52b,
      0xa93,
      0x40e95,
    );
    this.madd[0] = 0;
    this.madd[1] = 31;
    this.madd[2] = 59;
    this.madd[3] = 90;
    this.madd[4] = 120;
    this.madd[5] = 151;
    this.madd[6] = 181;
    this.madd[7] = 212;
    this.madd[8] = 243;
    this.madd[9] = 273;
    this.madd[10] = 304;
    this.madd[11] = 334;
  }

  /**
   * 获取当前的日期--日期，星期，时间
   */
  getNowTime(): any {
    let date = new Date();
    let weeks = new Array(
      "星期日",
      "星期一",
      "星期二",
      "星期三",
      "星期四",
      "星期五",
      "星期六",
    );
    let df = { rq: "", we: "", time: "" };
    let riqi =
      date.getFullYear() +
      "年" +
      (date.getMonth() + 1) +
      "月" +
      date.getDate() +
      "日";
    let week = weeks[date.getDay()];
    let minutes = date.getMinutes();
    let time = date.getHours() + ":" + this.formatTen(minutes);
    df.rq = riqi;
    df.we = week;
    df.time = time;
    return df;
  }

  /**
   * 获取农历日期信息
   */
  getChineseDate() {
    let date = new Date();
    let yy = date.getFullYear();
    let mm = date.getMonth() + 1;
    let dd = date.getDate();
    let yystring: string;
    if (yy < 100) {
      yystring = "19" + yy;
    } else {
      yystring = yy.toString();
    }
    return this.GetLunarDay(yystring, mm, dd);
  }

  /**
   * 获取日期，今天传0，昨天-1，明天1
   * @param AddDayCount
   */
  getFormatDate(AddDayCount) {
    var date = new Date();
    date.setDate(date.getDate() + AddDayCount); //获取AddDayCount天后的日期
    var seperator1 = "-";
    var month1 = date.getMonth() + 1;
    var strDate1 = date.getDate();
    let month = month1 > 9 ? month1 + "" : "0" + month1;
    let strDate = strDate1 > 9 ? strDate1 + "" : "0" + strDate1;
    var currentdate =
      date.getFullYear() + seperator1 + month + seperator1 + strDate;
    return currentdate;
  }

  GetBit(m, n) {
    return (m >> n) & 1;
  }

  //农历转换
  e2c() {
    this.TheDate =
      arguments.length != 3
        ? new Date()
        : new Date(arguments[0], arguments[1], arguments[2]);
    let total, m, n, k;
    let isEnd = false;
    let tmp = this.TheDate.getYear();
    if (tmp < 1900) {
      tmp += 1900;
    }
    total =
      (tmp - 1921) * 365 +
      Math.floor((tmp - 1921) / 4) +
      this.madd[this.TheDate.getMonth()] +
      this.TheDate.getDate() -
      38;

    if (this.TheDate.getYear() % 4 == 0 && this.TheDate.getMonth() > 1) {
      total++;
    }
    for (m = 0; ; m++) {
      k = this.CalendarData[m] < 0xfff ? 11 : 12;
      for (n = k; n >= 0; n--) {
        if (total <= 29 + this.GetBit(this.CalendarData[m], n)) {
          isEnd = true;
          break;
        }
        total = total - 29 - this.GetBit(this.CalendarData[m], n);
      }
      if (isEnd) break;
    }
    this.cYear = 1921 + m;
    this.cMonth = k - n + 1;
    this.cDay = total;
    if (k == 12) {
      if (this.cMonth == Math.floor(this.CalendarData[m] / 0x10000) + 1) {
        this.cMonth = 1 - this.cMonth;
      }
      if (this.cMonth > Math.floor(this.CalendarData[m] / 0x10000) + 1) {
        this.cMonth--;
      }
    }
  }

  GetcDateString() {
    let chineseYear = { nd: "", rl: "" };
    let tmp = "";
    let tmp1 = "";
    /*显示农历年：（ 如：甲午(马)年 ）*/
    tmp1 += this.tgString.charAt((this.cYear - 4) % 10);
    tmp1 += this.dzString.charAt((this.cYear - 4) % 12);
    tmp1 += "(";
    tmp1 += this.sx.charAt((this.cYear - 4) % 12);
    tmp1 += ")年 ";

    if (this.cMonth < 1) {
      tmp += "(闰)";
      tmp += this.monString.charAt(-this.cMonth - 1);
    } else {
      tmp += this.monString.charAt(this.cMonth - 1);
    }
    tmp += "月";
    tmp +=
      this.cDay < 11
        ? "初"
        : this.cDay < 20
          ? "十"
          : this.cDay < 30
            ? "廿"
            : "三十";
    if (this.cDay % 10 != 0 || this.cDay == 10) {
      tmp += this.numString.charAt((this.cDay - 1) % 10);
    }
    chineseYear.nd = tmp1;
    chineseYear.rl = tmp;
    return chineseYear;
  }

  GetLunarDay(solarYear, solarMonth, solarDay): any {
    if (solarYear < 1921 || solarYear > 2020) {
      return "";
    } else {
      solarMonth = parseInt(solarMonth) > 0 ? solarMonth - 1 : 11;
      //e2c(solarYear, solarMonth, solarDay);
      this.e2c();
      return this.GetcDateString();
    }
  }

  //格式化标准时间
  formatDate(date, useY = true) {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    if (useY)
      return year + "-" + this.formatTen(month) + "-" + this.formatTen(day);
    return this.formatTen(month) + "-" + this.formatTen(day);
  }

  formateTime(date, useS?) {
    const h = this.formatTen(date.getHours()) + ":";
    const m = this.formatTen(date.getMinutes());
    const s = ":" + this.formatTen(date.getSeconds());
    if (useS) return h + m + s;
    return h + m;
  }

  formatTen(num) {
    return num > 9 ? num + "" : "0" + num;
  }
}



// WEBPACK FOOTER //
// ./src/services/common/date-util.ts